import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';
import Image from '@/components/Image';

const defaultProps = {
  active: false,
};

const propTypes = {
  sourceUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  active: PropTypes.bool,
};

export default function EventGalleryItem({
  sourceUrl,
  index,
  active,
}) {
  return (
    <Transition
      show={active}
      enter="transition-opacity ease-linear duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity ease-linear duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      appear
    >
      <div className="aspect-w-16 aspect-h-9 absolute inset-0">
        <Image
          src={sourceUrl}
          alt={`Imagen ${index}`}
          className="object-contain w-full h-full"
        />
      </div>
    </Transition>
  );
}

EventGalleryItem.defaultProps = defaultProps;
EventGalleryItem.propTypes = propTypes;
